import { render, staticRenderFns } from "./adminMenu.vue?vue&type=template&id=17d98650&scoped=true&"
import script from "./adminMenu.vue?vue&type=script&lang=ts&"
export * from "./adminMenu.vue?vue&type=script&lang=ts&"
import style0 from "./adminMenu.vue?vue&type=style&index=0&id=17d98650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d98650",
  null
  
)

export default component.exports